var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"e3-svg",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":Number(_vm.size),"height":Number(_vm.size),"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M3,3H21V5H3V3M3,7H21V9H3V7M3,11H21V13H3V11M3,15H21V17H3V15M3,19H21V21H3V19Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }